import ServiceGraphQL from 'src/service/gql-service';
import { updateCustomer } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateCustomer = (variables) => {
  const params = {
    query: updateCustomer.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
